/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */

export type IndustrySector =
  (typeof IndustrySector)[keyof typeof IndustrySector];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IndustrySector = {
  BANK: "BANK",
  INSURANCE: "INSURANCE",
  ENERGY_SUPPLY: "ENERGY_SUPPLY",
  TRANSPORT: "TRANSPORT",
  LIFE_SCIENCE: "LIFE_SCIENCE",
  TELECOMMUNICATION: "TELECOMMUNICATION",
  IT: "IT",
  CONSTRUCTION: "CONSTRUCTION",
  TRADE_AND_CONSUMER_GOODS: "TRADE_AND_CONSUMER_GOODS",
  HEALTHCARE: "HEALTHCARE",
  GOVERNMENT_AGENCIES: "GOVERNMENT_AGENCIES",
  GENERAL: "GENERAL",
} as const;
